module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Logga in":"Sign in","För företag":"For business","För talanger":"For talents","Skapa anonym profil":"Create anonymous profile","asd":"asd"},"sv":{"Logga in":"Logga in","För företag":"För företag","För talanger":"För talanger","Skapa anonym profil":"Skapa anonym profil","asd":"asd"}}')
  delete Component.options._Ctor
}
